<template>
  <v-row>
    <v-col cols="12">
      <v-row no-gutters>
        <v-col>
          <div v-if="!userCanEdit" style="font-size: 25px; cursor: text;">
            {{ section.text }}
          </div>
          <content-editor
            v-else
            style="font-size: 25px; cursor: text; position: relative;"
            :value="{ html: section.text }"
            @input="
              updateSectionText({ contextId: context.id, sectionId: section.id, text: $event })
            "
            @mousedown.stop.prevent
            :ref="`editor`"
            class=""
            placeholder="New Section"
            allowTraversal
            :emitText="true"
            @keyDownLastLine=""
            @keyEnter=""
            @keyShiftTab=""
          ></content-editor>
        </v-col>
        <v-btn
          v-if="sectionPages.length == 0"
          icon
          cols="1"
          @click="removeSection({ sectionId: section.id })"
        >
          <v-icon color="red lighten-2">
            delete
          </v-icon>
        </v-btn>
        <v-btn icon cols="1" @click="expand = !expand">
          <v-icon :style="expand ? 'transform: rotate(180deg)' : null">
            keyboard_arrow_down
          </v-icon>
        </v-btn>
      </v-row>
      <v-divider></v-divider>
    </v-col>
    <v-expand-transition>
      <v-col v-show="expand" cols="12" class="py-0">
        <section-page :sectionId="section.id" :hideHeader="true"></section-page>
      </v-col>
    </v-expand-transition>
  </v-row>
</template>

<script>
import SectionPage from '../SectionPage';
import ContentEditor from '../../ContentEditor';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  components: { SectionPage, ContentEditor },
  props: ['section'],
  data() {
    return {
      expand: true
    };
  },
  computed: {
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['context', 'userCanEdit']),
    ...mapState('pages', ['pages']),
    sectionPages() {
      return Object.values(this.pages).filter(p => p.section == this.section.id);
    }
  },
  methods: {
    ...mapActions('context', ['updateSectionText', 'removeSection']),
    focus() {
      this.$refs.editor.focus();
    }
  }
};
</script>

<style></style>
